import React, { useEffect, useState } from "react";
import {
  Table,
  Button,
  Card,
  Tooltip,
  Dropdown,
  Menu,
  message,
  Modal,
  Input,
  Space,
} from "antd";
import {
  MoreOutlined,
  PlusOutlined,
  EditOutlined,
  DeleteOutlined,
} from "@ant-design/icons";
import httpInjectorService from "../../services/http-injector.service";

const CompanyList = () => {
  const [companies, setCompanies] = useState([]);
  const [loading, setLoading] = useState(true);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [newCompanyName, setNewCompanyName] = useState("");

  useEffect(() => {
    fetchCompanies();
  }, []);

  const fetchCompanies = async () => {
    setLoading(true);
    try {
      const res = await httpInjectorService.companyList();
      if (res.status === "SUCCESS") {
        setCompanies(res.data);
      } else {
        setCompanies([]);
        message.warning("No companies found.");
      }
    } catch (error) {
      console.error(error);
      message.error("Failed to fetch companies.");
    } finally {
      setLoading(false);
    }
  };

  const handleAddCompany = async () => {
    if (!newCompanyName.trim()) {
      message.warning("Company name cannot be empty.");
      return;
    }

    try {
      const res = await httpInjectorService.addCompany({ name: newCompanyName });
      if (res.status === "SUCCESS") {
        message.success("Company added successfully");
        setIsModalVisible(false);
        setNewCompanyName("");
        fetchCompanies();
      } else {
        message.error(res.message || "Failed to add company.");
      }
    } catch (error) {
      console.error(error);
      message.error("Failed to add company.");
    }
  };

  const handleMenuClick = (record, action) => {
    if (action === "edit") {
      message.info(`Edit action clicked for ${record.company_name}`);
    } else if (action === "delete") {
      message.info(`Delete action clicked for ${record.company_name}`);
    }
  };

  const columns = [
    {
      title: "Company Name",
      dataIndex: "company_name",
      key: "company_name",
    },
    {
      title: "",
      key: "actions",
      render: (_, record) => (
        <Dropdown
          overlay={
            <Menu
              onClick={({ key }) => handleMenuClick(record, key)}
              items={[
                {
                  key: "edit",
                  icon: <EditOutlined />,
                  label: "Edit",
                },
                {
                  key: "delete",
                  icon: <DeleteOutlined />,
                  label: "Delete",
                },
              ]}
            />
          }
          trigger={["click"]}
        >
          <Button icon={<MoreOutlined />} />
        </Dropdown>
      ),
      width: 60,
    },
  ];

  return (
    <Card
     bordered
        style={{
          borderRadius: "12px",
          boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
          width: "100%",
          minHeight: "600px",
          display: "flex",
          flexDirection: "column",
        }}
        bodyStyle={{
          padding: "20px",
          display: "flex",
          flexDirection: "column",
          overflowY: "auto",
          flex: 1,
        }}
        className="hide-scrollbar"
      title="Companies"
      extra={
      <Tooltip title="Add new company">
  <Button
    style={{ background: "#0D2481", color: "white" }}
    icon={<PlusOutlined style={{ color: "white" }} />}
    onClick={() => setIsModalVisible(true)}
  >
  </Button>
</Tooltip>


      }
    >
      <Table
        columns={columns}
        dataSource={companies}
        loading={loading}
        rowKey="id"
        pagination={false}
      />

      <Modal
        title="Add New Company"
        visible={isModalVisible}
        onCancel={() => setIsModalVisible(false)}
        onOk={handleAddCompany}
        okText="Add"
      >
        <Input
          placeholder="Enter company name"
          value={newCompanyName}
          onChange={(e) => setNewCompanyName(e.target.value)}
        />
      </Modal>
    </Card>
  );
};

export default CompanyList;
